import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export const convertTimestampToDate = (timestamp: string | number): string => {
  return dayjs.utc(timestamp).format('MM/DD/YYYY');
};

export const convertSecondsToMinutes = (seconds: number): number => {
  return Math.round(seconds / 60);
};

export const formatDate = (date: string) => {
  if (!date) {
    return null;
  }

  const [year, month, day] = date.split('-');
  return `${month}/${day}/${year}`;
};
